export const AuthDretsImatge = ({ auth, handleChange, error, major18 }) => {

  return (<>
    <div className="row">
      <div className="col col-12 ">
        <h4>
          Drets d'imatge
        </h4>

        <p>
          L’Institut Jaume Mimó disposa de diversos espais web i d’entorns de treball on informa i fa difusió
          de les seves activitats lectives, complementàries i extraescolars.
          Als web s’hi poden publicar imatges en les quals apareixen, individualment o en grup, alumnes
          realitzant les activitats esmentades.<br />
          <br />
          Donat que el dret a la pròpia imatge està reconegut a l’Article 18.1 de la Constitució espanyola iregulat
          per la Llei orgànica 1/1982, del 5 de maig, sobre el dret a l’honor, a la intimitat personal i familiar i a la
          pròpia imatge, la Direcció d’aquest centre demana el consentiment a les famílies (en cas de menors
          d’edat) o a l’alumnat major d’edat per publicar fotograﬁes on hi aparegui i sigui clarament
          identiﬁcables.<br />
          <br />
          Així mateix, els informem que el centre disposa de càmeres de videovigilància per tal de vetllar per
          la seguretat de tota la comunitat educativa. L’enregistrament de les imatges són susceptibles de
          consulta per part de la Direcció en casos d’incompliment amb la normativa. Aquestes imatges es
          conservaran un termini màxim d’un mes i no es faran públiques en cap moment.<br />
          <br />

          <input type="checkbox"
            id="authDretsImatge"
            name="authDretsImatge"
            value={auth}
            checked={auth === "1" ? true : false}
            onChange={(t) => { handleChange(t.target.value) }
            } />

          <label htmlFor="authDretsImatge">
            AUTORITZO
            {!major18 ?
              (<> que la imatge i/o veu de l'alumnat matriculat </>) : (<> que la meva imatge i/o veu </>)}
            pugui aparèixer en fotografies i vídeos corresponents a
            les activitats lectives, complementàries, extraescolars i de promoció i difusó organitzades per l'institut i publicades a pàgines WEB,
            xares socials, filmacions no comercials o revistes i publicacions d'àmbit educatiu.
          </label>
          <span id="auhtDretsImatge_ERROR" className="a-Form-error">{error}</span>
        </p>
      </div>
    </div>

    <br />
  </>)
}
